import { Amplify } from 'aws-amplify';
import awsmobile from './aws-exports';
import Homepage from './views/homepage/index.jsx';

Amplify.configure(awsmobile);

function App() {
  return <Homepage />;
}

export default App;